export default __webpack_public_path__ + "static/media/rodolfo_ok.63c06ad0.png";